import type { ReactNode } from 'react';

export function Loading({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="state">
      <div className="spinner" />
      <div>{label}</div>
    </div>
  );
}

export function Empty({ children }: { children: ReactNode }) {
  return <div className="state">{children}</div>;
}

export function Failed({ error }: { error: unknown }) {
  const message = error instanceof Error ? error.message : String(error);

  return (
    <div className="banner">
      <span aria-hidden="true">⚠</span>
      <div>
        <strong>Could not load this data.</strong>
        <div className="muted" style={{ marginTop: 4 }}>
          {message}
        </div>
      </div>
    </div>
  );
}
